import { CardType } from 'types/deck'

import Icon from 'components/elements/Icon'

import styles from './companionTag.module.scss'

type Props = {
  card: CardType
}

const CompanionTag = ({ card }: Props) => {
  if (!card.companion) return null

  return (
    <div className={styles.tag}>
      <Icon name="paw" />
    </div>
  )
}

export default CompanionTag
